/**
 * Created by Andrey Popov on 08.10.2021.
 */
const AtlasAnalyzerScene = cc.Scene.extend({
    ctor: function (atlasAnalyzer, options) {
        this._super();

        this.atlasAnalyzer = atlasAnalyzer;
        this.options = options;

        this.sceneComponent = ComponentMap.attach(this, new SceneComponent({
            bundles: ["admin"],
            sceneName: cleverapps.Environment.SCENE_ATLAS_ANALYZER
        }));
    },

    onSceneLoaded: function () {
        const options = this.options;
        const bundlesExplorerView = new BundlesExplorerView(this.atlasAnalyzer.bundlesExplorer);
        const textureImageView = new TextureImageView(this.atlasAnalyzer.textureImage);
        const imageSpyView = new ImageSpyView(this.atlasAnalyzer.imageSpy);

        const horizontalLayout = this.horizontalLayout = new cleverapps.Layout([bundlesExplorerView, textureImageView, imageSpyView], {
            direction: cleverapps.UI.HORIZONTAL
        });

        horizontalLayout.setAlignment(0, 0);
        horizontalLayout.setAnchorPoint(0, 0);
        this.addChild(horizontalLayout);

        this.atlasAnalyzer.showUp(options.tab || "Main", options.bundleName, options.frame);

        cleverapps.debugStats.setEnabled(false);
    },

    onResize: function () {
        this.sceneComponent.removeFilmEffect();
        this.sceneComponent.onResizeWhileNotLoaded();
        if (this.background) {
            this.background.setContentSize2(cleverapps.resolution.getBgSize());
        }
        this.horizontalLayout.reshape();
    },

    onCloseAction: function () {
        cleverapps.debugStats.setEnabled(true);

        cleverapps.setUrlHash({
            atlasAnalyzer: undefined, tab: undefined, bundleName: undefined, frame: undefined
        });
    }
});

AtlasAnalyzerScene.open = function (atlasAnalyzer, bundleName) {
    (cleverapps.focusManager.isFocused() ? cleverapps.focusManager.distract : cleverapps.focusManager.display).call(cleverapps.focusManager, {
        focus: "atlasAnalyzer",
        control: ["ControlButtonsView"],
        action: function (f) {
            cleverapps.scenes.replaceScene(new AtlasAnalyzerScene(atlasAnalyzer, {
                bundleName
            }), f);
        }
    });
};

cleverapps.styles.AtlasAnalyzerScene = {
    offsetTop: 90
};

(function () {
    const params = cleverapps.getRequestParameters(location.hash);
    if (!params.atlasAnalyzer || !cleverapps.config.debugMode) {
        return;
    }

    cleverapps.Plot.onStartup = function (f, returnClassOnly) {
        if (returnClassOnly) {
            return AtlasAnalyzerScene;
        }

        if (!cleverapps.atlasAnalyzer) {
            cleverapps.atlasAnalyzer = new AtlasAnalyzer(params.tab);
        }
        const atlasAnalyzer = cleverapps.atlasAnalyzer;

        const scene = new AtlasAnalyzerScene(atlasAnalyzer, {
            tab: params.tab,
            bundleName: params.bundleName,
            frame: params.frame
        });
        cleverapps.scenes.replaceScene(scene, f);
    };
}());